import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postStock,
  putStock,
  deleteStock,
  postRawMaterial,
  putRawMaterial,
  deleteRawMaterial
} from '@galo-monitor/services/apis/galoMonitorApi/resources/rawMaterialsStocks'

import { RawMaterialsStocksActions, RawMaterialsStocksTypes } from './duckRawMaterialsStocks'

function* saveStock({ stock, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(stock.id ? putStock : postStock , stock)
    yield call(onSuccess)
  } catch (err) {
    yield put(RawMaterialsStocksActions.planError(err.message))
    yield call(onError, err)
  }
}

function* removeStock({ stock, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteStock, stock)
    yield call(onSuccess)
  } catch (err) {
    yield put(RawMaterialsStocksActions.planError(err.message))
    yield call(onError, err)
  }
}

function* saveRawMaterial({ rawMaterial, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(rawMaterial.id ? putRawMaterial : postRawMaterial , rawMaterial)
    yield call(onSuccess)
  } catch (err) {
    yield put(RawMaterialsStocksActions.planError(err.message))
    yield call(onError, err)
  }
}

function* removeRawMaterial({ rawMaterial, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteRawMaterial, rawMaterial)
    yield call(onSuccess)
  } catch (err) {
    yield put(RawMaterialsStocksActions.planError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(RawMaterialsStocksTypes.SAVE_STOCK, saveStock),
  takeLatest(RawMaterialsStocksTypes.REMOVE_STOCK, removeStock),
  takeLatest(RawMaterialsStocksTypes.SAVE_RAW_MATERIAL, saveRawMaterial),
  takeLatest(RawMaterialsStocksTypes.REMOVE_RAW_MATERIAL, removeRawMaterial)
]
